import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import { Model } from 'backbone';
import contentTemplate from 'behaviors/properties/main/notify/edit-notification-message.ejs';
import selectFieldModal from 'common-views/SelectFieldModalView';
import attachmentsModal from 'behaviors/properties/main/notify/AttachmentsModalView';
import Constants from 'Constants.js'
import AccountService from 'AccountService';
import notificationEmailAttachmentModal from 'designer/modals/NotificationEmailAttachmentModal';
import util from 'util/Util';

class EditNotificationMessageView extends BasePropertyView {

    initialize(opts) {
        this.options = opts || {};

        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = '#editNotificationMessage';
        this.factoryKey = opts.factoryKey;
        this.table = Constants.PROP_MAIN_TABLE_NOTIFICATION_VIEW;
        this.activeInput = '';
        this.selectionStart = 0;

        if (this.factoryKey === undefined) {
            this.factoryKey = this.model.attributes.factoryKey;
        }
        if (this.model.get('messageSendEmail') === false || this.model.get('messageSendEmail') === 'false') {
            this.model.set('messageSendEmailString', '', {silent: true});
        } else {
            this.model.set('messageSendEmail', true);
            this.model.set('messageSendEmailString', 'checked', {silent: true});
        }
        if (!this.model.get('messageText')) {
            this.model.set('messageText', '', {silent: true});
        }
        if (!this.model.get('messageHtml')) {
            this.model.set('messageHtml', '', {silent: true});
        }
        if (!this.model.get('messageSubject')) {
            this.model.set('messageSubject', '', {silent: true});
        }

        this.events = {
            'change input[type=text]': 'updateAttributes',
            'change input[type=checkbox]': 'updateCheckboxAttributes',
            'change textarea': 'updateAttributes',
            'blur textarea, input[type=text]': 'lostFocus',
            'focus textarea, input[type=text]': 'getFocus',
            'click .insertLink': 'insertLink',
            'click #insertInstance': 'insertInstance',
            'click #insertField': 'showValueFieldModal',
            'click #attachments': 'attachmentClick'
        };

        return this;
    }

    lostFocus(ev) {
        super.lostFocus(ev);
        this.selectionStart = ev.currentTarget.selectionStart;
    }

    getFocus(ev) {
        super.getFocus(ev);
        this.activeInput = ev.currentTarget.id;
    }

    updateAttributes(ev) {
        const propName = ev.currentTarget.id;
        let propVal = ev.currentTarget.value;

        if(propName === "messageSubject"){
            propVal = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));
        }
        else{
            propVal = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName), true);
        }

        this.model.set( propName, propVal );
        this.updateGrid(propName, propVal);
    }

    updateCheckboxAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.checked;
        var newValue = "";
        if (propVal) {
            newValue = "checked";
        }
        this.model.set(propName, propVal);
        this.model.set(propName + 'String', newValue);
        this.updateGrid(propName, propVal);
    }

    showValueFieldModal(ev) {
        ev.preventDefault();

        var sfModal = new selectFieldModal({model: new Model(), mode: 'insertField', target:'notifications'});
        sfModal.render().then((selectedField)=>{
            if (this.activeInput !== 'messageSubject') {
                let fieldToAdd = '';
                let fieldId = selectedField.id;
                let name = selectedField.name.toLowerCase();
                if (name.indexOf('drop-down') > -1 && name.indexOf('caption') > -1) {
                    fieldId += '$v';
                }

                let activeTextArea = this.getActiveTextArea();
                if (activeTextArea && activeTextArea === 'messageText') {
                    fieldToAdd = '{' + selectedField.name + '}';
                } else {
                    fieldToAdd = '{field name="' + selectedField.name + '" id="' + fieldId + '"}';
                }

                let result = this.stringInserted(this.model.get(activeTextArea), fieldToAdd).trim();
                result = result.replace(/<br[^>]*>/gi, '\n');

                $('#' + activeTextArea).val(result);

                this.model.set(activeTextArea, result);
                this.updateGrid(activeTextArea, result);

            }else{
                let fieldToAdd =  '{' + selectedField.name + '}';
                let result=this.stringInserted(this.model.get('messageSubject'),  fieldToAdd).trim();
                result= $('<div/>').html(result).text();

                this.model.set('messageSubject',result, {silent: true});
                this.updateGrid('messageSubject', result);
                $('#messageSubject').val(result);
            }
        }).catch(err => console.log(err));

    }

    showAttachmentModal() {
        let response = {};
        response.insertAttachmentSelected = this.model.get('insertAttachmentSelected');
        response.insertAttachment = this.model.get('insertAttachment')? this.model.get('insertAttachment'): '';
        response.insertCheck = this.model.get('insertCheck')? this.model.get('insertCheck'): 'false';
        response.printAttachmentSelected = this.model.get('printAttachmentSelected');
        response.printAttachment = this.model.get('printAttachment')? this.model.get('printAttachment'): '';
        response.printCheck = this.model.get('printCheck')? this.model.get('printCheck'): 'false';
        response.existingInstanceAttachmentSelected = this.model.get('existingInstanceAttachmentSelected');
        response.existingInstanceAttachment = this.model.get('existingInstanceAttachment')?
            this.model.get('existingInstanceAttachment'): '';
        response.instanceCheck = this.model.get('instanceCheck')? this.model.get('instanceCheck'): 'false';

        var sfModal = new attachmentsModal({model: new Model({data: response })});
        sfModal.render().then((response)=>{

            this.model.set('insertAttachmentSelected', response.insertAttachmentSelected, {silent:true});
            this.model.set('insertAttachment', response.insertAttachment, {silent:true});
            this.model.set('insertCheck', response.insertCheck, {silent:true});
            this.model.set('printAttachmentSelected', response.printAttachmentSelected, {silent:true});
            this.model.set('printAttachment', response.printAttachment, {silent:true});
            this.model.set('printCheck', response.printCheck, {silent:true});
            this.model.set('existingInstanceAttachmentSelected', response.existingInstanceAttachmentSelected, {silent:true});
            this.model.set('existingInstanceAttachment', response.existingInstanceAttachment, {silent:true});
            this.model.set('instanceCheck', response.instanceCheck, {silent:true});

            this.updateGrid('insertAttachmentSelected', response.insertAttachmentSelected);
            this.updateGrid('insertAttachment', response.insertAttachment);
            this.updateGrid('insertCheck', response.insertCheck);
            this.updateGrid('printAttachmentSelected', response.printAttachmentSelected);
            this.updateGrid('printAttachment', response.printAttachment);
            this.updateGrid('printCheck', response.printCheck);
            this.updateGrid('existingInstanceAttachmentSelected', response.existingInstanceAttachmentSelected);
            this.updateGrid('existingInstanceAttachment', response.existingInstanceAttachment);
            this.updateGrid('instanceCheck', response.instanceCheck);
        }).catch(err => console.log(err));
    }

    showEmailAttachmentInformation(){
        var informationModal = new notificationEmailAttachmentModal({model: new Model()});
                        informationModal.render().then((result)=> {
                            return ('OK');
                        }).catch((error) => {
                            var msg = error || 'Unknown Error';
                            console.log('Notification email attachment information modal: ', msg)
                            return (error);
                        });
    }

    attachmentClick(ev){
        let allowAttachment = AccountService.verifyEmailAttachments();
        if(allowAttachment){
           this.showAttachmentModal();
        }
          else{
           this.showEmailAttachmentInformation();  
        }
    }

    getActiveTextArea() {
        let activeTab = $("#messageBody .active");
        let result = null;
        if (activeTab.length > 0 ) {
            result =  activeTab[0].id.replace('LI', '');
        }
        return result;
    }

    insertLink(e) {
        e.preventDefault();
        let element=$(e.currentTarget);
        let value=element.attr('value');
        let defaultLink=$('.default-link');

        if(element.hasClass('lnk')){
            if(element.hasClass('sso')){
                defaultLink.text('Insert SSO Link');
                defaultLink.attr('value','ssolink');
                defaultLink.removeClass('sso').addClass('sso');
            }else{
                defaultLink.removeClass('sso');
                defaultLink.text('Insert Link');
                defaultLink.attr('value','|non-ssolink|');
            }
        }

        const LINK = '{|'+value+'|}';
        let activeTextArea = this.getActiveTextArea();
        if (activeTextArea) {
            this.model.set(activeTextArea, this.stringInserted(this.model.get(activeTextArea),  LINK));
            $('#'+activeTextArea).val(this.model.get(activeTextArea))
        }
        this.updateGrid(activeTextArea, this.model.get(activeTextArea))
    }

    insertInstance(){
        const INSTANCE = '{|InstanceNumber|}';
        if(this.activeInput!=='messageSubject'){           
           let activeTextArea = this.getActiveTextArea();
           if (activeTextArea) {
               this.model.set(activeTextArea, this.stringInserted(this.model.get(activeTextArea),  INSTANCE));
               $('#'+activeTextArea).val(this.model.get(activeTextArea))
               this.updateGrid(activeTextArea, this.model.get(activeTextArea));
           }
        }else{
            let result=this.stringInserted(this.model.get('messageSubject'),  INSTANCE).trim();
            result= $('<div/>').html(result).text();

            this.model.set('messageSubject',result, {silent: true});
            this.updateGrid('messageSubject', result);
            $('#messageSubject').val(result);
        }
    }

    updateGrid(field, value) {
        let id = $(this.table).getGridParam('selrow');
        let rowData = $(this.table).getRowData(id);
        rowData[field] = value;
        $(this.table).setRowData(id, rowData);
    }

    stringInserted(original,insert){
        let firstPart = original.slice(0,this.selectionStart);
        let secondPart = original.slice(this.selectionStart,original.length);
        return firstPart+insert+secondPart;

    }

    stringInsertedChange(original,insert, id){
        let firstPart = original.slice(0,this.selectionStart);
        let secondPart = original.slice(this.selectionStart,original.length);
        return (firstPart+ '{field id="'+id+'"}'+secondPart).replace(insert,'');

    }

    render() {
        if (this.model.get('messageSendEmail') === false || this.model.get('messageSendEmail') === 'false') {
            this.model.set('messageSendEmailString', '', {silent:true});
        } else {
            this.model.set('messageSendEmail', true, {silent:true});
            this.model.set('messageSendEmailString', 'checked', {silent:true});
        }
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        return this;

    }
}

export default EditNotificationMessageView;
